import { isFlashHotelType } from 'lib/offer/offerTypes'

export function getTotalChildren(filters?: App.OfferListFilters): number {
  return filters?.rooms?.reduce((sum, room) => sum + (room.children ?? 0), 0) ?? 0
}

export function getTotalInfants(filters?: App.OfferListFilters): number {
  return filters?.rooms?.reduce((sum, room) => sum + (room.infants ?? 0), 0) ?? 0
}

/**
 * Returns the number of children/infants that stay free based on included
 * guests across all packages.
 *
 * When `includedGuests` data exists it is treated as the source of truth: the
 * searched room must not exceed one included guest shape in every rate.
 *
 * Returns 0 when the offer is not a flash hotel type, no guests are
 * genuinely free, or no children/infants are in the search filters.
 */
export function getFlashFreeChildCount({
  offerType,
  filters,
  includedGuestsByRate,
}: {
  offerType: App.OfferType
  filters?: App.OfferListFilters
  includedGuestsByRate?: Array<Array<App.PackageRoomIncludedGuests>>
}): number {
  if (!isFlashHotelType(offerType)) return 0

  const rooms = filters?.rooms ?? []
  const includedGuestsRates = includedGuestsByRate ?? []
  if (includedGuestsRates.length === 0) return 0

  const includedGuestsCoverRoom = (includedGuests: Array<App.PackageRoomIncludedGuests>, room: App.Occupants) => {
    return includedGuests.some(includedGuest =>
      includedGuest.adults >= (room.adults ?? 0) &&
      includedGuest.children >= (room.children ?? 0) &&
      includedGuest.infants >= (room.infants ?? 0) &&
      includedGuest.teenagers >= (room.teenagers ?? 0),
    )
  }

  return rooms.reduce((freeCount, room) => {
    const roomMatchesIncludedGuests = includedGuestsRates.every(includedGuests =>
      includedGuestsCoverRoom(includedGuests, room),
    )

    return roomMatchesIncludedGuests ? freeCount + (room.children ?? 0) + (room.infants ?? 0) : freeCount
  }, 0)
}
